import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ConvertPointsAPI from "../../../../../apiConfig/ConvertPoints";

export const status = {
  INITIAL: "INITIAL",
  LOADING: "LOADING",
  LOADED: "LOADED",
  EMPTY: "EMPTY",
  ERROR: "ERROR",
};

const initialState = {
  transection: null,
  status: status.INITIAL,
  errorMessage: null,
};

//Thunks
export const fetchAsyncConvertPoints = createAsyncThunk(
  "coins/fetchAsyncConvertPoints",
  async ({
    trueIdToken,
    swapPairId,
    fromUnit,
    exchangeRate
  }, { rejectWithValue }) => {
    try {
      const response = await ConvertPointsAPI.post(
        '/api/redeem-points', 
        {
          swapPairId: +swapPairId,
          fromUnit: +fromUnit,
          exchangeRate: +exchangeRate
        },
      );
      return {
        status: response.status,
        data: response.data,
      };
    } catch (err) {
      return rejectWithValue({
        status: err.response.status,
        data: err.response.data,
      });
    }
  }
);

//Slices
const ConvertPoints = createSlice({
  name: "convertPoints",
  initialState,
  reducers: {
    resetConvertPoints: (state) => {
      state.transection = null;
      state.errorMessage = null;
      state.status = status.INITIAL;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAsyncConvertPoints.pending, (state) => {
        state.errorMessage = null;
        state.status = status.LOADING;
      })
      .addCase(fetchAsyncConvertPoints.fulfilled, (state, { payload }) => {
        if (payload.data === undefined) {
          state.status = status.ERROR;
          return;
        }

        state.transection = payload.data;
        state.errorMessage = null;
        state.status = status.LOADED;
      })
      .addCase(fetchAsyncConvertPoints.rejected, (state, { payload }) => {
        if (payload === undefined) {
          state.status = status.ERROR;
          return;
        }
        state.errorMessage = payload.data;
        state.status = status.ERROR;
      });
  },
});

export const { resetConvertPoints } = ConvertPoints.actions;

export default ConvertPoints.reducer;
